import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  EventService,
  BusinessProfileService,
  EventApplicationService,
  AuthService,
  TicketService,
  DocumentService,
  GlobalSettingService,
  SalesAudienceService,
} from "../../services";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../utils/common-methods";
import EventPageModel from "../../components/Model/EventPageModel";
import { GlobalConstant, Routes } from "../../constants";
import CustomModal from "../../components/Modal/Modal";
import TicketPaymentCard from "../Common/TicketPaymentCard";
import { useDispatch, useSelector } from "react-redux";
import * as CONSTANTS from "../../redux/Models/Application/constants";
import { toast } from "react-toastify";
import {
  ApplicationType,
  EventStatus,
  UserRoleType,
} from "../../constants/Enum";
import Swal from "sweetalert2";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const EventPage = (props) => {
  const { eventurl } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [eventData, setEventData] = useState({ ...EventPageModel });
  const [tickets, setTickets] = useState(null);
  const [ticketQuantity, setTicketQuantity] = useState(0);
  const [IsPublishedEvent, setPublishedEvent] = useState(false);
  const [ticketAmount, setTicketAmount] = useState(0);
  let loginUser = AuthService.getLoginUser();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEligible, setEligible] = useState(false);
  const [paymentLineItems, setPaymentLineItems] = useState([]);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [cardProcessingFee, setProcessingPercent] = useState(0);
  const [vatPercent, setVatPercent] = useState(0);
  const currentModel = useSelector((state) => state?.application?.currentModel);

  const isPlatformVatRegister = true;
  const [stripePromise, setStripePromise] = useState(null);
  const [isPreEventMessaging, setPreEventMessaging] = useState(false);
  const [stripeDetails, setStripeDetails] = useState("");

  const [paymentDetails, setPaymentDetails] = useState({
    id: null, // Guid?
    ticketid: "",
    userId: loginUser?.id, // Guid
    title: "Buy Ticket", // string?
    amount: 0,
    ticketFeeAmount: 0,
    connectedAccountId: "", //"acct_1QjaTOPfU6Vw7G4t",
    isFinalPayment: true,
    quantity: 0,
  });

  const [
    showFullParkingInstructions,
    setShowFullParkingInstructions,
  ] = useState(false);
  const convertTo12HourFormat = (time) => {
    const [hours, minutes, seconds] = time?.split(":").map(Number);

    // Create a new date object (set to a dummy date, like 1st Jan 1970)
    const date = new Date();
    date.setHours(hours, minutes, seconds);

    // Get the hours and minutes in 12-hour format
    let hours12 = date.getHours() % 12 || 12; // Get hours in 12-hour format
    let minutesVal = date
      .getMinutes()
      .toString()
      .padStart(2, "0");
    let ampm = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM/PM

    return `${hours12}:${minutesVal} ${ampm}`;
  };
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    focusOnSelect: false,
    infinite: false,
    autoplay: false,
    speed: 5000,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const parkinginstructionsText = eventData?.parkinginstructions || "";
  const displayTerms =
    parkinginstructionsText?.length > 0
      ? parkinginstructionsText?.length > 190 && !showFullParkingInstructions
        ? `${parkinginstructionsText?.substring(
            0,
            190
          )} <a href="#!" className="toggle-text">show more...</a>`
        : `${parkinginstructionsText} <a href="#!" className="toggle-text">show less</a>`
      : "";

  const getApplicationType = (appType) => {
    if (appType === ApplicationType.Tender) {
      return "Tender";
    }
    if (appType === ApplicationType.Bid) {
      return "Live Auction";
    }
    if (appType === ApplicationType.Turnover) {
      return "Turnover";
    }

    return "Fixed Price";
  };

       const getStripeDetails = async () => {
        try {
          const res = await GlobalSettingService.getStripeDetails();
          if (res?.isSuccess && res?.data) {
              setStripeDetails( GlobalSettingService.decrypt(res?.data?.keyValue));        
          }
        } catch (error) {
        const message=  handleConsoleError(error);
          toast.error(error?.message|| message);
        }
      };
        useEffect(() => {        
          const fetchDetails = async () => {
              await Promise.all([
            getStripeDetails(),
            props.application.getSwallowEO(),
             ]);
          };
          fetchDetails();
        },[stripeDetails]);

  useEffect(() => {
    if (currentModel !== "") {
      setModalOpen(true);
    } else {
      setModalOpen(false);
    }

    const fetchEventOrganizer = async (userId) => {
      if (!userId) return;
      try {
        const res = await BusinessProfileService.getBusinessProfileById(userId);
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({
            ...prev,
            organizerName: res?.data?.businessName,
            organizerLogo: res?.data?.businessLogoUrl,
            userId: res?.data.userId,
          }));
          if (res?.data.isActive === false) {
            setPublishedEvent(res?.data.isActive);
          }
        }
      } catch (error) {
      const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      }
    };

    const fetchCateringApplications = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "C"
        );
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({ ...prev, cateringApplications: res?.data }));
        }
      } catch (error) {
       const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      }
    };

    const fetchRetailApplications = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "R"
        );
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({ ...prev, retailApplications: res?.data }));
        }
      } catch (error) {
       const message= handleConsoleError(error, "Failed to fetch retail apps:");
        toast.error(error?.message|| message);
      }
    };

    const fetchEventSalesData = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await SalesAudienceService.getEventSalesById(eventId);
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({ ...prev, sales: res?.data }));
        }
      } catch (error) {
       const message= handleConsoleError(error, "fetch event sales data");
        toast.error(error?.message|| message);
      }
    };

    const fetchEventMap = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await EventService.getEventMapById(eventId);
        if (res?.isSuccess && res?.data) {
          setEventData((prev) => ({ ...prev, maps: res?.data }));
        }
      } catch (error) {
       const message= handleConsoleError(error, "fetch event map");
        toast.error(error?.message|| message);
      }
    };

    const fetchEventDocuments = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await DocumentService.getEventDocumentEventById(eventId);
        if (res?.isSuccess && res?.data) {
          const activeDocs = res?.data.filter((x) => x.isActive);
          setEventData((prev) => ({ ...prev, documents: activeDocs }));
        }
      } catch (error) {
       const message= handleConsoleError(error, "fetch event document");
        toast.error(error?.message|| message);
      }
    };

    const fetchTickets = async (eventId) => {
      if (!eventId) return;
      try {
        const res = await TicketService.getTicketByEventId(eventId);
        if (res?.isSuccess && res?.data) {
          setTickets(res?.data);
        }
      } catch (error) {
        const message= handleConsoleError(error, "fetch ticket");
        toast.error(error?.message|| message);
      }
    };

    const fetchGlobalValues = async () => {
      try {
        const res = await GlobalSettingService.getGlobalSettingList();
        if (res?.isSuccess && res?.data?.length > 0) {
          const processFeePercent = res?.data.find(
            (item) =>
              item.keyName.trim() === GlobalConstant.PROCESS_PERCENT.trim()
          );
          if (processFeePercent)
            setProcessingPercent(processFeePercent?.keyValue);

          const vat = res?.data.find(
            (item) => item.keyName.trim() === GlobalConstant.VAT_PERCENT.trim()
          );
          if (vat) {
            setVatPercent(vat?.keyValue);
          }

          const preEventMessaging = res?.data.find(
            (item) =>
              item.keyName.trim() === GlobalConstant.PRE_EVENT_MESSAGING.trim()
          );
          if (preEventMessaging && preEventMessaging.isActive === true) {
            setPreEventMessaging(true);
          }
        }
      } catch (error) {
       const message=  handleConsoleError(error, "Failed to fetch global value:");
        toast.error(error?.message|| message);
      }
    };

    const fetchEventData = async () => {
      try {
        if (!eventurl || eventurl.length <= 5) {
          navigate(routes.ERROR);
          return;
        }

        props.application.setLoading(true);

        const res = await EventService.getEventByURL(eventurl);

        if (res?.isSuccess && res?.data) {
          const event = res?.data;
          setPublishedEvent(
            event?.eventStatusId === EventStatus.Published ||
              event?.eventStatusId === EventStatus.InProgress
          );
          await Promise.all([
            fetchEventOrganizer(event?.usersId),
            fetchGlobalValues(),
            fetchCateringApplications(event?.id),
            fetchRetailApplications(event?.id),
            fetchEventMap(event?.id),
            fetchEventDocuments(event?.id),
            fetchTickets(event?.id),
            fetchEventSalesData(event?.id),
          ]);

          setEventData((prev) => ({ ...prev, ...event }));
        }

        props.application.setLoading(false);
      } catch (error) {
        props.application.setLoading(false);
       const  message= handleConsoleError(error, "Failed to fetch event data:");
        toast.error(error?.message|| message);
      }
    };

    fetchEventData();
  }, [eventurl]);

  useEffect(() => {}, [ticketQuantity]);

  const EventStateCountry = () => {
    return (
      formatNull(eventData?.stateName) +
      formatNullWithOutComma(eventData.countryName)
    );
  };
  const formatNull = (add) => {
    return add ? add + ", " : "";
  };
  const formatNullWithOutComma = (add) => {
    return add ? add : "";
  };
  const EventAddress = () => {
    return (
      formatNull(eventData.street1) +
      formatNull(eventData.street2) +
      formatNull(eventData.city) +
      formatNull(eventData.stateName) +
      formatNullWithOutComma(eventData.countryName)
    );
  };

  const EventDate = () => {
    /* { Apr 04, 2025 · 10:00 AM - Apr 06, 2025 · 6:00 PM}{" "} */
    const startDate =
      (eventData.startDate ? formatDateENGB(eventData?.startDate) : "") +
      " " +
      (eventData.startTime ? convertTo12HourFormat(eventData?.startTime) : "");
    const endDate =
      (eventData.endDate ? formatDateENGB(eventData?.endDate) : "") +
      " " +
      (eventData.endTime ? convertTo12HourFormat(eventData?.endTime) : "");

    return startDate?.trim() + "-" + endDate?.trim();
  };
  const handleOnChange = () => {};

  const addDefaultImg = (e) => {
    e.target.src = routes.DEFAULT_IMAGE;
  };

  const formatLongDate = (startDate) => {
    const currentDate = new Date(startDate);
    return currentDate.toLocaleDateString("en-US", {
      weekday: "long", // Day of the week (e.g., "Monday")
      year: "numeric", // Full year (e.g., "2025")
      month: "long", // Full month name (e.g., "January")
      day: "numeric", // Day of the month (e.g., "16")
    });
  };

  const handleTicketDropdownChange = async (e) => {
    try {
      const quantity = parseInt(e.target.value, 10);
      if (loginUser) {
        setTicketQuantity(quantity);
        if (quantity === 0) {
          return;
        }
        props.application.setLoading(true);
        const res = await TicketService.checkTicketEligibility(
          tickets?.id,
          quantity
        );
        props.application.setLoading(false);
        if (res?.isSuccess && res?.data) {
          setEligible(res?.data?.isEligible);
          if (!res?.data?.isEligible) {
            toast.error(res?.message);
          } else {
            if (res?.data?.lineItems && res?.data?.lineItems.length > 0) {
              let ticketPlatformFeeItem = res?.data?.lineItems.find(
                (x) => x.name === "Booking Fee"
              );
              let ticketFeeAmount = ticketPlatformFeeItem?.amount;
              if (isPlatformVatRegister) {
                const buyerFeeVat =
                  ticketPlatformFeeItem?.vat > 0
                    ? ticketPlatformFeeItem?.vat
                    : (ticketFeeAmount * vatPercent) / 100;
                ticketFeeAmount = ticketFeeAmount + buyerFeeVat;
              }
              setPaymentLineItems(res?.data?.lineItems);
              setTicketAmount(`${formatAmount(res?.data?.lineItems[2].total)}`);
              setPaymentDetails({
                ...paymentDetails,
                connectedAccountId: res?.data?.connectedAccount,
                ticketid: tickets?.id,
                amount: res?.data?.lineItems[2].total || 0,
                ticketFeeAmount: ticketFeeAmount,
                title: tickets.name,
                quantity: quantity,
              });
              try {
                const stripe = await loadStripe(
                  `${stripeDetails}`, // safer than hardcoding
                  { stripeAccount: res?.data?.connectedAccount }
                );

                setStripePromise(stripe);
              } catch (error) {
                const message= handleConsoleError(error, "Failed to initialize stripe");
                toast.error(error?.message|| message);
              }
            }
          }
        }
      } else {
        dispatch({
          type: CONSTANTS.SET_CURRENT_MODAL,
          payload: CONSTANTS.LOGIN_MODAL,
        });
      }
    } catch (error) {
      props.application.setLoading(false);
     const message=  handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const closeModal = () => {
    setTicketQuantity(0);
    setModalOpen(false);
  };

  const closeConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const handleCatererApply = () => {
    if (
      loginUser &&
      loginUser?.role !== UserRoleType.TRADERRETAILER &&
      loginUser?.role !== UserRoleType.MOBILECATERERS
    ) {
      Swal.fire({
        title: "Application Warning!",
        text:
          "You are not authorised to apply as a Caterer. Please login as a Trader/Mobile Caterer.",
        icon: "warning",
        buttonsStyling: false,
      });
      return;
    } else {
      if (!loginUser) {
        localStorage.setItem("returnUrl", routes.EVENT_PAGE + "/" + eventurl);
        dispatch({
          type: CONSTANTS.SET_CURRENT_MODAL,
          payload: CONSTANTS.LOGIN_MODAL,
        });
        return;
      }
      navigate(
        routes.EVENT_APPLICATION_LANDING.replace(":type", "C").replace(
          ":eventId",
          eventData?.id
        )
      );
    }
  };

  const handleRetailApply = () => {
    if (
      loginUser &&
      loginUser?.role !== UserRoleType.TRADERRETAILER &&
      loginUser?.role !== UserRoleType.MOBILECATERERS
    ) {
      Swal.fire({
        title: "Application Warning!",
        text:
          "You are not authorised to apply as a Retail Trade Stand. Please login as a Trader/Mobile Caterer.",
        icon: "warning",
        buttonsStyling: false,
      });
      return;
    } else {
      if (!loginUser) {
        localStorage.setItem("returnUrl", routes.EVENT_PAGE + "/" + eventurl);
        dispatch({
          type: CONSTANTS.SET_CURRENT_MODAL,
          payload: CONSTANTS.LOGIN_MODAL,
        });
        return;
      }
      navigate(
        routes.EVENT_APPLICATION_LANDING.replace(":type", "R").replace(
          ":eventId",
          eventData?.id
        )
      );
    }
  };
  const handlePayClick = () => {
    if (!loginUser || (loginUser && loginUser?.role !== UserRoleType.CUSTOMER)) {
      Swal.fire({
        title: "Ticket Purchase",
        text:
          "You are not authorized to purchase tickets. Please login as a Customers/Ticket Buyers.",
        icon: "warning",
        buttonsStyling: false,
      });
      return;
    } else {
      setConfirmModalOpen(true); // Open confirmation modal first
    }
  };

  const handleConfirmPurchase = () => {
    setConfirmModalOpen(false); // Close confirmation modal
    setModalOpen(true); // Open payment modal
  };

  const getTicketImage = (ticketImage, eventImage) => {
    return ticketImage && ticketImage.length > 2
      ? ticketImage
      : eventImage && eventImage.length > 2
      ? eventImage
      : routes.DEFAULT_IMAGE;
  };
  const handleMessageClick = async (e, id) => {
    try {
      e.preventDefault();
      props.application.setLoading(true);
      const res = await EventService.getEventOrganiserBussnessProfileByEventId(
        id
      );
      if (res?.isSuccess && res?.data) {
        props.application.setLoading(false);
        navigate(routes.MESSAGE_INBOX, {
          state: {
            toUser: res?.data,
            isRedirect: true,
            isPreEventMessage: true,
            eventName: eventData?.eventName,
          },
        });
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message=  handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  //TODO swallow org id

  const shouldShowMessageButton =
    isPreEventMessaging &&
    //eventData.eventStatusId === EventStatus.Published &&
    eventData?.usersId?.toLowerCase() ===
      props.application.swallowEO?.toLowerCase() &&
    (loginUser?.role === UserRoleType.MOBILECATERERS ||
      loginUser?.role === UserRoleType.TRADERRETAILER);

  return (
    <Elements stripe={stripePromise}>
      <React.Fragment>
        <section className="delray-affair-events">
          <div className="container slider-container">
            {/* <div className="slider"> */}
            <Slider classNameName="slider slider-nav" {...settings}>
              <div>
                <div className="slide">
                  <img
                    src={eventData?.coverPicWide}
                    alt=""
                    className="img-responsive dummy"
                    onError={addDefaultImg}
                    // sizes={{ width: "1376px", height: "688px" }}
                  />
                  <div className="affair-events-text">
                    <div className="affair-events-text1">
                      <h4>{eventData?.eventName}</h4>
                      <h6>
                        {eventData.startDate &&
                          "Starts on " + formatLongDate(eventData?.startDate)}
                      </h6>
                      <h5>{EventAddress()}</h5>
                    </div>
                    <div className="affair-events-text2">
                      <div className="host">
                        <h5>
                          Hosted by<br></br>
                          <span>
                            <Link
                              to={`${Routes.TRADER_PROFILE.replace(
                                ":id",
                                eventData?.usersId
                              ).replace(":appId", eventurl)}`}
                            >
                              <span> {eventData?.organizerName}</span>{" "}
                            </Link>
                            <img
                              src={eventData?.organizerLogo}
                              alt=""
                              onError={addDefaultImg}
                            ></img>
                          </span>
                          {shouldShowMessageButton && (
                            <button
                              title="Send A Message To The Event Organiser"
                              onClick={async (e) => {
                                handleMessageClick(e, eventData?.id);
                              }}
                              style={{
                                marginRight: "10px",
                                marginTop: "10px",
                                background: "#5b5b5b",
                                border: "#5b5b5b",
                                color: "#ffffff",
                                fontSize: "18px",
                              }}
                            >
                              Message Organiser
                            </button>
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </section>
        <section className="affair-events-tabs">
          <div className="container">
            <div className="warpper">
              <input
                className="radio"
                id="one"
                name="group"
                type="radio"
                checked
                onChange={handleOnChange}
              />
              <input className="radio" id="two" name="group" type="radio" />
              <input className="radio" id="three" name="group" type="radio" />

              <div className="tabs">
                <label className="tab" id="one-tab" htmlFor="one">
                  <a href="#one-tab">Overview</a>
                </label>
                {eventData.cateringApplications.length > 0 &&
                  eventData.cateringApplications.filter((x) => x.isActive)
                    .length > 0 && (
                    <label className="tab" htmlFor="two">
                      <a href="#two-tab" className="cat1">
                        Caterer
                      </a>
                    </label>
                  )}
                {eventData.retailApplications.length > 0 &&
                  eventData.retailApplications.filter((x) => x.isActive)
                    .length > 0 && (
                    <label className="tab" htmlFor="three">
                      <a href="#three-tab" className="cat1">
                        Retail Trade Stands
                      </a>
                    </label>
                  )}
                {tickets && (
                  <label className="tab" htmlFor="four">
                    <a href="#four-tab" className="cat1">
                      Ticketing
                    </a>
                  </label>
                )}
                {(eventData.documents ?? []).length > 0 && (
                  <label className="tab" htmlFor="four">
                    <a href="#five-tab" className="cat1">
                      Documents
                    </a>
                  </label>
                )}
                {eventData.maps.length > 0 && (
                  <label className="tab" htmlFor="four">
                    <a href="#sixth-tab" className="cat1">
                      Site Plan
                    </a>
                  </label>
                )}
                {(eventData?.totalAudience > 0 ||
                  eventData.sales.length > 0) && (
                  <label className="tab" htmlFor="four">
                    <a href="#seventh-tab" className="cat1">
                      Past Sales
                    </a>
                  </label>
                )}
              </div>

              <div className="panels">
                <div className="panel" id="one-panel">
                  <div className="about-us-events">
                    <h3>About the event</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: eventData?.eventDecription,
                      }}
                    />
                  </div>

                  <div className="location-park-events mb-3">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="date">
                          <h3>
                            <i className="fa-solid fa-calendar-days"></i> Dates
                          </h3>
                          <h5>{EventDate()}</h5>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="date location">
                          <h3>
                            <i className="fa-solid fa-location-dot"></i>{" "}
                            Location
                          </h3>
                          <h5>{EventStateCountry()}</h5>
                          <h4>{EventAddress()}</h4>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="date">
                          <h3>
                            <i className="fa-solid fa-square-parking"></i>{" "}
                            Parking instructions
                          </h3>
                          <h5
                            dangerouslySetInnerHTML={{
                              __html: displayTerms,
                            }}
                            onClick={(e) => {
                              if (e.target.className === "toggle-text") {
                                e.preventDefault();
                                setShowFullParkingInstructions((prev) => !prev);
                              }
                            }}
                          ></h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="about-us-events ">
                    <h3>Opening Times-</h3>
                    <p>
                      Please refer to the event listing for detailed opening and trading times.
                      {/* {eventData.eventName} is open to the public from{" "}
                      {eventData.startTime
                        ? convertTo12HourFormat(eventData.startTime)
                        : ""}{" "}
                      to{" "}
                      {eventData.endTime
                        ? convertTo12HourFormat(eventData.endTime)
                        : ""}{" "}
                      each day of the {eventData.eventName}. */}
                    </p>
                  </div>
                  {eventData.cateringApplications.length > 0 &&
                    eventData.cateringApplications.map((application, index) => {
                      const deadlineDate = new Date(application?.deadLine);

                      // Normalize both dates to compare only the date (ignore time)
                      const deadlineDateOnly = new Date(
                        deadlineDate.getFullYear(),
                        deadlineDate.getMonth(),
                        deadlineDate.getDate()
                      );
                      const todayDateOnly = new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate()
                      );

                      if (application.isActive) {
                        return (
                          <div
                            id="two-tab"
                            className="artists-vender-events"
                            key={index}
                          >
                            <h2>Caterer</h2>
                            <h5>Interested in applying:</h5>

                            <div className="artists-one">
                              <div className="artists-one-img">
                                {application.image === null ||
                                application.image === "" ? (
                                  <img
                                    src={routes.DEFAULT_IMAGE}
                                    onError={addDefaultImg}
                                    alt=""
                                    style={{ objectFit: "cover" }}
                                  />
                                ) : (
                                  <img
                                    src={application.image}
                                    alt=""
                                    onError={addDefaultImg}
                                    style={{ objectFit: "cover" }}
                                  />
                                )}
                              </div>
                              <div className="artists-one-text">
                                <h3>{application?.title}</h3>
                                <h4>
                                  Deadline:
                                  <span>
                                    {" "}
                                    {formatDateENGB(application?.deadLine)}
                                  </span>
                                </h4>
                                <p>{application?.smallDecription}</p>
                                <h4>
                                  Application Type:
                                  <span>
                                    <strong>
                                      {getApplicationType(
                                        application?.applicationType
                                      )}
                                    </strong>
                                  </span>
                                </h4>
                                <div
                                  className="button-img-icon-gray"
                                  bis_skin_checked="1"
                                >
                                  <div
                                    className="button-img-icon1-gray"
                                    bis_skin_checked="1"
                                  >
                                    <a
                                      href="#!"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      <small className="text-muted-gray">
                                        Buyer Fee:{" "}
                                        {eventData?.commissionPercentage ?? 0}%
                                      </small>
                                    </a>
                                  </div>

                                  <div
                                    className="button-img-icon1-gray"
                                    bis_skin_checked="1"
                                  >
                                    <a
                                      href="#!"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      <small className="text-muted-gray">
                                        Processing Fee: {cardProcessingFee}%
                                      </small>
                                    </a>
                                  </div>
                                </div>
                                <div className="bt-artists">
                                  {IsPublishedEvent && (
                                    <a
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleCatererApply();
                                      }}
                                    >
                                      {deadlineDateOnly >= todayDateOnly
                                        ? "Apply now"
                                        : "Closed"}
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return <></>;
                      }
                    })}
                  {eventData.retailApplications.length > 0 &&
                    eventData.retailApplications.map((application, index) => {
                      const deadlineDate = new Date(application?.deadLine);

                      // Normalize both dates to compare only the date (ignore time)
                      const deadlineDateOnly = new Date(
                        deadlineDate.getFullYear(),
                        deadlineDate.getMonth(),
                        deadlineDate.getDate()
                      );
                      const todayDateOnly = new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate()
                      );

                      if (application.isActive) {
                        return (
                          <div
                            id="three-tab"
                            className="artists-vender-events"
                            key={index}
                          >
                            <h2>Retail Trade Stands</h2>
                            <h5>Interested in applying:</h5>

                            <div className="artists-one">
                              <div className="artists-one-img">
                                {application.image === null ||
                                application.image === "" ? (
                                  <img
                                    src={routes.DEFAULT_IMAGE}
                                    alt=""
                                    onError={addDefaultImg}
                                    style={{ objectFit: "cover" }}
                                  />
                                ) : (
                                  <img
                                    src={application.image}
                                    alt=""
                                    onError={addDefaultImg}
                                    style={{ objectFit: "cover" }}
                                  />
                                )}
                              </div>
                              <div className="artists-one-text">
                                <h3>{application?.title}</h3>
                                <h4>
                                  Deadline:
                                  <span>
                                    {" "}
                                    {formatDateENGB(application?.deadLine)}
                                  </span>
                                </h4>
                                <p>{application?.smallDecription}</p>
                                <h4>
                                  Application:
                                  <span>
                                    <strong>
                                      {getApplicationType(
                                        application?.applicationType
                                      )}
                                    </strong>
                                  </span>
                                </h4>
                                <div
                                  className="button-img-icon-gray"
                                  bis_skin_checked="1"
                                >
                                  <div
                                    className="button-img-icon1-gray"
                                    bis_skin_checked="1"
                                  >
                                    <a
                                      href="#!"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      <small className="text-muted-gray">
                                        Buyer Fee:{" "}
                                        {eventData?.commissionPercentage ?? 0}%
                                      </small>
                                    </a>
                                  </div>

                                  <div
                                    className="button-img-icon1-gray"
                                    bis_skin_checked="1"
                                  >
                                    <a
                                      href="#!"
                                      style={{ pointerEvents: "none" }}
                                    >
                                      <small className="text-muted-gray">
                                        Processing Fee: {cardProcessingFee}%
                                      </small>
                                    </a>
                                  </div>
                                </div>
                                <div className="bt-artists">
                                  {IsPublishedEvent && (
                                    <a
                                      href="#!"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleRetailApply();
                                      }}
                                      // to={routes.EVENT_APPLICATION_LANDING.replace(
                                      //   ":type",
                                      //   "R"
                                      // ).replace(":eventId", eventData?.id)}
                                    >
                                      {deadlineDateOnly >= todayDateOnly
                                        ? "Apply now"
                                        : "Closed"}
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return <></>;
                      }
                    })}
                  {/* if event status is published then only sale ticket */}
                  {/* {tickets && ( */}
                  {tickets && (
                    <div id="four-tab" className="artists-vender-events">
                      <h2>Ticketing</h2>
                      <div className="artists-one">
                        <div className="artists-one-img">
                          <img
                            src={getTicketImage(
                              tickets?.imageUrl,
                              eventData?.coverPicWide
                            )}
                            alt=""
                            onError={addDefaultImg}
                          />
                        </div>
                        <div className="artists-one-text">
                          <h3>{tickets?.name}</h3>
                          <h4>
                            Deadline:{" "}
                            <span>{formatDateENGB(tickets.endTime)}</span>
                          </h4>
                          <p>Price: £ {formatAmount(tickets.price ?? 0)} </p>
                          {/* <small className="text-muted">
                          Booking Fee: £ {formatAmount(tickets.adminFee ?? 0)} ,
                          Processing Fee: £{" "}
                          {formatAmount(tickets.processingFee ?? 0)}
                        </small> */}
                          <div
                            className="button-img-icon-gray"
                            bis_skin_checked="1"
                          >
                            <div
                              className="button-img-icon1-gray"
                              bis_skin_checked="1"
                            >
                              <a href="#!" style={{ pointerEvents: "none" }}>
                                <small className="text-muted-gray">
                                  Buyer Fee: £{" "}
                                  {formatAmount(tickets.adminFee ?? 0)}
                                </small>
                              </a>
                            </div>

                            <div
                              className="button-img-icon1-gray"
                              bis_skin_checked="1"
                            >
                              <a href="#!" style={{ pointerEvents: "none" }}>
                                <small className="text-muted-gray">
                                  Processing Fee: £{" "}
                                  {formatAmount(tickets.processingFee ?? 0)}
                                </small>
                              </a>
                            </div>
                          </div>
                          <span></span>
                          {IsPublishedEvent && (
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div
                                className="count-pitch mb-3"
                                style={{ marginTop: "8px" }}
                              >
                                <label
                                  style={{ marginBottom: "0px" }}
                                  htmlFor="ticketQuantity"
                                >
                                  Quantity:
                                </label>{" "}
                                <input
                                  type="number"
                                  id="ticketQuantity"
                                  name="retailApplicationFormData.selectedPitches.pitchQty"
                                  value={ticketQuantity}
                                  onChange={(e) =>
                                    handleTicketDropdownChange(e)
                                  }
                                  min="1"
                                  max={tickets?.allowPerUser}
                                  className="form-control"
                                  style={{ minWidth: "65px" }}
                                />
                                <small className="text-muted">
                                  You can purchase up to {tickets?.allowPerUser}{" "}
                                  tickets.
                                </small>
                                <strong style={{ whiteSpace: "nowrap" }}>
                                  X £{" "}
                                  {formatAmount(
                                    tickets?.price +
                                      tickets?.adminFee +
                                      tickets?.processingFee
                                  )}{" "}
                                </strong>
                              </div>
                            </div>
                          )}

                          {IsPublishedEvent &&
                            ticketQuantity > 0 &&
                            isEligible && (
                              <div className="col-sm-12 col-md-12 col-lg-12 ">
                                <button
                                  onClick={handlePayClick}
                                  className="text-end"
                                >
                                  Pay £{formatAmount(ticketAmount)}
                                </button>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  )}
                  {(eventData.documents ?? []).length > 0 && (
                    <div id="five-tab" className="artists-vender-events">
                      <h2>Documents</h2>
                      <div
                        style={{
                          display: "flex",
                          padding: 10,
                          columnGap: 20,
                          flexWrap: "wrap",
                        }}
                      >
                        {eventData.documents.map((document, index) => (
                          <Link
                            key={index}
                            to={document?.documentFileURL}
                            target="_blank"
                          >
                            <div
                              style={{
                                textAlign: "center",
                                border: "1px solid #ec2f7c",
                                borderRadius: 5,
                                minWidth: 100,
                                marginTop: 10,
                              }}
                            >
                              <div style={{ height: "70%", padding: 10 }}>
                                <img
                                  style={{ width: 50, height: 50 }}
                                  src="/assets/images/svg/filetype-pdf.svg"
                                  alt=""
                                ></img>
                              </div>
                              <div
                                style={{
                                  height: "30%",
                                  backgroundColor: "#ec2f7c",
                                  textAlign: "center",
                                  padding: 5,
                                }}
                              >
                                <span style={{ color: "white" }}>
                                  {document?.documentName}
                                </span>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                  {eventData.maps.length > 0 && (
                    <div id="sixth-tab" className="artists-vender-events">
                      <h2>Site Plan</h2>
                      <div
                        style={{
                          display: "flex",
                          padding: 10,
                          columnGap: 20,
                          flexWrap: "wrap",
                        }}
                      >
                        {eventData.maps.map((map, index) => (
                          <Link  key={index} to={map?.mapFile} target="_blank">
                            <div
                              style={{
                                textAlign: "center",
                                border: "1px solid #ec2f7c",
                                borderRadius: 5,
                                minWidth: 100,
                                marginTop: 10,
                              }}
                            >
                              <div style={{ height: "70%", padding: 10 }}>
                                <img
                                  style={{ width: 50, height: 50 }}
                                  src="/assets/images/svg/filetype-pdf.svg"
                                  alt=""
                                ></img>
                              </div>
                              <div
                                style={{
                                  height: "30%",
                                  backgroundColor: "#ec2f7c",
                                  textAlign: "center",
                                  padding: 5,
                                }}
                              >
                                <span
                                  title={map?.title}
                                  style={{
                                    color: "white",
                                    display: "inline-block",
                                    textOverflow: "ellipsis",
                                    maxWidth: 200,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                >
                                  {map?.title}
                                </span>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                  {(eventData?.totalAudience > 0 ||
                    eventData.sales.length > 0) && (
                    <div id="seventh-tab" className="artists-vender-events">
                      <h2>Past Sales</h2>
                      <div
                        style={{
                          padding: 10,
                        }}
                      >
                        <i className="fa-solid fa-users"></i>{" "}
                        <b>Audience Number: </b>
                        <span>{eventData?.totalAudience}</span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          padding: 10,
                          columnGap: 20,
                          flexWrap: "wrap",
                        }}
                      >
                        {eventData.sales.map((sale, index) => (
                          <Link key={index} to={sale.file} target="_blank">
                            <div
                              style={{
                                textAlign: "center",
                                border: "1px solid #ec2f7c",
                                borderRadius: 5,
                                minWidth: 100,
                                marginTop: 10,
                              }}
                            >
                              <div style={{ height: "70%", padding: 10 }}>
                                <i
                                  style={{
                                    fontSize: "24px",
                                  }}
                                  className="fa-solid fa-download"
                                ></i>
                              </div>
                              <div
                                style={{
                                  height: "30%",
                                  backgroundColor: "#ec2f7c",
                                  textAlign: "center",
                                  padding: 5,
                                }}
                              >
                                <span
                                  title={sale?.fileTitle}
                                  style={{
                                    color: "white",
                                    display: "inline-block",
                                    textOverflow: "ellipsis",
                                    maxWidth: 200,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                  }}
                                >
                                  {sale?.fileTitle}
                                </span>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="panel" id="two-panel">
                  <div className="panel-title">Take-Away Skills</div>
                  <p>
                    You will learn many aspects of styling web pages! You’ll be
                    able to set up the correct file structure, edit text and
                    colors, and create attractive layouts. With these skills,
                    you’ll be able to customize the appearance of your web pages
                    to suit your every need!
                  </p>
                </div>

                <div className="panel" id="three-panel">
                  <div className="panel-title">Note on Prerequisites</div>
                  <p>
                    We recommend that you complete Learn HTML before learning
                    CSS.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/****** Confirmation Modal *********/}
        <CustomModal isOpen={isConfirmModalOpen} onClose={closeConfirmModal}>
          <div style={{ padding: 20, textAlign: "center" }}>
            <h3>Are you sure you want to buy tickets?</h3>
            <button onClick={handleConfirmPurchase} style={{ marginRight: 10 }}>
              Confirm
            </button>
            <button
              style={{ background: " #454545" }}
              onClick={closeConfirmModal}
            >
              Cancel
            </button>
          </div>
        </CustomModal>

        {/****** PAYMENT MODEL ******/}
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <TicketPaymentCard
            eventData={eventData}
            lineItems={paymentLineItems}
            paymentDetails={paymentDetails}
            onClose={closeModal}
          ></TicketPaymentCard>
        </CustomModal>
      </React.Fragment>
    </Elements>
  );
};

export default injectModels(["application"])(EventPage);
